module.exports = "/_next/static/images/fb295d5d70fbfdb9af6e9ca4b20735d2-boy-looking-to-the-front-md@2x.jpg.webp";